import { createContext } from "react";
import { Auth } from "../types/AuthType";

export const AuthContext = createContext<Auth>({
  authenticated: false,
  user: {},
  rootFolderId: null,
  signIn: async () => ({ status: 'failed', message: 'Not implemented' }),
  signUp: async () => ({ status: 'failed', message: 'Not implemented' }),
  signOut: () => {},
  updateUser: () => {}
});